<template>
  <div>
    <Drawer title="用户详情" width="900" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Row>
        <Col span="12" class="info-item">
          <span>用户ID:</span>
          <span>{{baseInfo.user_id}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>昵称:</span>
          <span>{{baseInfo.nick_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>手机号:</span>
          <span class="important-word">{{baseInfo.mobile}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>性别:</span>
          <span>{{baseInfo.gender}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>用户类型:</span>
          <span>{{baseInfo.user_type_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>真实姓名:</span>
          <span>{{baseInfo.real_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>身份证号:</span>
          <span>{{baseInfo.id_card}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>注册时间:</span>
          <span>{{baseInfo.create_time}}</span>
        </Col>

        <template v-if="baseInfo.user_type === 1">
          <Col span="12" class="info-item">
            <span>车牌号:</span>
            <span class="important-word">{{baseInfo.car_number}}</span>
          </Col>
          <Col span="12" class="info-item">
            <span>车型:</span>
            <span>{{baseInfo.car_model}}</span>
          </Col>
        </template>

      </Row>


          <pageTable tabelRef="orderTable"
                     :tableTitle="orderTableColumn"
                     :searchData="{}"
                     :tableHeight="300"
                     :defaultSearchParam="{user_id:this.user_id}"
                     tableApi="admin/order/getUserOrder"
          >
          </pageTable>

    </Drawer>
  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "edit",
    components:{pageTable},
    props:{
      showEdit:{
        type:Boolean,
        default: false
      },
      user_id:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        baseInfo:{},
        orderTableColumn:[
          {title:'升数',key:'litre_num',align:'center'},
          {title:'站点',key:'gas_name',align:'center'},
          {title:'油价(元/L)',key:'buy_price',align:'center'},
          {title:'购买总价',key:'total_price',align:'center'},
          {title:'下单时间',key:'create_time',align:'center',width:180},
        ],
      }
    },
    methods:{
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/my_company/getDriverInfo',{user_id:this.user_id});
        this.$commonFun.dealApiResult(res,()=>{
          this.baseInfo = res.data
        })
      },
      cancelEdit(){
         this.$emit('cancel-edit')
      },
      reloadPage(user_id){
        this.$parent.reloadDetail(user_id)
      }
    },
    mounted() {
        this.getInfo()
    },
    watch:{
      user_id(val){
       /* console.log(val)
        this.getInfo()*/
      }
    }
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
